import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';

// Case overview query per docs/ui/operator-ui-tds.md §6.2 — staleTime 60s.
// The central applyEvent merge (NEX-149) keeps this fresh via StateChanged
// events, so we tolerate stale-on-mount and let WS pushes drive subsequent
// updates without HTTP refetches.

export interface CaseOverviewSummary {
  caseUrn: string;
  status?: string;
  airportCode?: string;
  passengerCount?: number;
  // Friendly-header inputs (frontend-conventions §18.3).
  flightUrn?: string | null;
  openedAt?: string | null;
  /** ISO-8601 UTC departure instant — for date display in the airport's timezone. */
  departureAt?: string | null;
  /** IATA-3 origin airport code — for timezone-aware date formatting. */
  origin?: string | null;
  locked_by?: { operatorUrn: string; displayName: string } | null;
  lock_expires_at?: string | null;
  // Governing-policy provenance (POL-12) — which policy governs this case + why.
  governingPolicyUrn?: string | null;
  policyMatchType?: string | null;
  policyMatchReason?: string | null;
  /** Care-only case: no flight rebooking — hotels/meals/transport only. */
  rebookingDisabled?: boolean | null;
  [key: string]: unknown;
}

export function useCaseOverview(caseUrn: string) {
  return useQuery<CaseOverviewSummary>({
    queryKey: ['cases', caseUrn, 'overview'],
    queryFn: () => http.get(`v1/cases/${encodeURIComponent(caseUrn)}`).json<CaseOverviewSummary>(),
    staleTime: 60_000,
    enabled: !!caseUrn,
  });
}
